import React from 'react';
import styles from './TransportationHeader.module.scss';

interface TransportationHeaderProps {
    title: string;
}

export const TransportationHeader: React.FC<TransportationHeaderProps> = ({ title }) => {
    return (
        <div className={styles.container}>
            <p className={styles.title}>{title}</p>
            <div className={styles.divider} />
        </div>
    );
};

export default TransportationHeader;
